export default "__VITE_ASSET__4CTbMhPJ__"